/**
 * Whether this viewer already dismissed the first-run intro. Kept per device
 * and per user; blocked or wiped storage only means the intro shows again.
 */
const keyFor = (userId: string) => `mioscape.intro.dismissed.${userId}`;

export function introDismissed(userId: string): boolean {
  try {
    return window.localStorage.getItem(keyFor(userId)) === "1";
  } catch {
    return false;
  }
}

export function dismissIntro(userId: string): void {
  try {
    window.localStorage.setItem(keyFor(userId), "1");
  } catch {
    // Storage is a convenience here; the app works the same without it.
  }
}
